module.exports = __webpack_public_path__ + "img/different.f2e43a95.png";